import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var rxSubscriber = typeof _Symbol === 'function' ? /*@__PURE__*/_Symbol('rxSubscriber') : '@@rxSubscriber_' + /*@__PURE__*/Math.random();
export var $$rxSubscriber = rxSubscriber;